import { useParams } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import DailyPlannerPageInput from "../../../components/NewsLetter/DailyPlannerPageInput";
import Layout from "../../../Layout";

const CreateDailyPlanner = () => {
  const params = useParams();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "planner",
      route: "/planner",
    },
    {
      title: "Add Planner",
      route: "/shore/daily-planner/genting-dream/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={params.vessel.replace("-", " ")}>
      <CustomHeaderTitle title={"Create New Planner"} />
      <HeaderBread
        navigation={navigation}
        title={"Add New Planner"}
      ></HeaderBread>
      <DailyPlannerPageInput newsletter={{}} />
    </Layout>
  );
};

export default CreateDailyPlanner;
